var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.setTitle(),
        visible: _vm.show,
        width: "70%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "user",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.formValidate,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("account"), prop: "account" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formValidate.account,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "account", $$v)
                          },
                          expression: "formValidate.account",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("zsxm"), prop: "nickname" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formValidate.nickname,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "nickname", $$v)
                          },
                          expression: "formValidate.nickname",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("txje"), prop: "withdraw_money" },
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formValidate.withdraw_money,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "withdraw_money", $$v)
                          },
                          expression: "formValidate.withdraw_money",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("sxfje"), prop: "deduct_money" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formValidate.deduct_money,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "deduct_money", $$v)
                          },
                          expression: "formValidate.deduct_money",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("sjdzje"), prop: "reality_money" },
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formValidate.reality_money,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "reality_money", $$v)
                          },
                          expression: "formValidate.reality_money",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("tjsj"), prop: "create_time" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.formValidate.create_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.formValidate, "create_time", $$v)
                          },
                          expression: "formValidate.create_time",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("yhkxx"), name: "first" },
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("qbxx"), name: "second" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "first",
                  expression: "activeName == 'first'",
                },
              ],
              attrs: { label: _vm.$t("bankmc"), prop: "bank_name" },
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.formValidate.bank_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "bank_name", $$v)
                  },
                  expression: "formValidate.bank_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "first",
                  expression: "activeName == 'first'",
                },
              ],
              attrs: { label: _vm.$t("bankzhmc"), prop: "bank_branch_name" },
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.formValidate.bank_branch_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "bank_branch_name", $$v)
                  },
                  expression: "formValidate.bank_branch_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "first",
                  expression: "activeName == 'first'",
                },
              ],
              attrs: { label: _vm.$t("bankzh"), prop: "bank_account" },
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.formValidate.bank_account,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "bank_account", $$v)
                  },
                  expression: "formValidate.bank_account",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "second",
                  expression: "activeName == 'second'",
                },
              ],
              attrs: { label: _vm.$t("qbmc"), prop: "wallet_name" },
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.formValidate.wallet_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "wallet_name", $$v)
                  },
                  expression: "formValidate.wallet_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "second",
                  expression: "activeName == 'second'",
                },
              ],
              attrs: { label: _vm.$t("qbdz"), prop: "wallet_address" },
            },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.formValidate.wallet_address,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "wallet_address", $$v)
                  },
                  expression: "formValidate.wallet_address",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("cljd"), prop: "review_status" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formValidate.review_status,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "review_status", $$v)
                    },
                    expression: "formValidate.review_status",
                  },
                },
                [
                  _c("el-radio", { attrs: { disabled: "", label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("wsh"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { disabled: _vm.formType != "examine", label: 1 },
                    },
                    [_vm._v(_vm._s(_vm.$t("shtg")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio",
                    {
                      attrs: { disabled: _vm.formType != "examine", label: 2 },
                    },
                    [_vm._v(_vm._s(_vm.$t("shwtg")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formValidate.review_status == 2,
                  expression: "formValidate.review_status == 2",
                },
              ],
              attrs: { label: _vm.$t("explain"), prop: "explain" },
            },
            [
              _c("el-input", {
                attrs: {
                  disabled: _vm.formType != "examine",
                  placeholder: _vm.$t("qsrjjly"),
                },
                model: {
                  value: _vm.formValidate.explain,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "explain", $$v)
                  },
                  expression: "formValidate.explain",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formType == "examine",
                  expression: "formType == 'examine'",
                },
              ],
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }